import Axios from 'axios'

// eslint-disable-next-line no-unused-vars
const apiClient = Axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export default {
  getConstants() {
    return apiClient.post('/Constants/api/Constants/GetAllValue', {
      option: 'all',
    })
  },
  getMonthlyFeeIllness(age) {
    return apiClient.post(
      '/Monthly_fee_illness/api/Monthly_fee_illness/GetValueByAge',
      {
        age,
      }
    )
  },
  getMonthlyFee(age) {
    return apiClient.post('/Monthly/api/Monthly_fee/GetValueByAge', {
      age,
    })
  },
  getPercentage() {
    return apiClient.post('/Alivia/api/Alivia/GetAllValue', {
      Option: 'all',
    })
  },
}
